import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { DeleteOutlineIcon } from "../../shared/components/icons";
import { PhotoCameraIcon } from "../../shared/components/icons";
import { MicIcon } from "../../shared/components/icons";

export interface PendingListEntry {
  name: string;
  size: number;
  kind: "photo" | "audio";
}

/**
 * Staged media awaiting a container save (ticket 11): photo/audio entries the
 * form will upload once it is saved, each removable with one tap.
 */
export function PendingUploadList({
  pending,
  onRemove,
}: {
  pending: PendingListEntry[];
  onRemove: (index: number) => void;
}) {
  if (pending.length === 0) return null;
  return (
    <List dense>
      {pending.map((a, i) => (
        <ListItem
          key={`${a.kind}-${i}`}
          secondaryAction={
            <IconButton
              edge="end"
              aria-label={`remove ${a.name}`}
              onClick={() => onRemove(i)}
            >
              <DeleteOutlineIcon />
            </IconButton>
          }
        >
          <ListItemIcon>{a.kind === "photo" ? <PhotoCameraIcon /> : <MicIcon />}</ListItemIcon>
          <ListItemText primary={a.name} secondary={`${a.size} bytes`} />
        </ListItem>
      ))}
    </List>
  );
}